import { useCallback } from "react";

import {
  AddonTemplate,
  isAircraftAddonTemplate,
  isSoftwareAddonTemplate,
} from "../lib/model/addonTemplate";

import { useLibraryState } from "./useEditorState";

export const useCTA = () => {
  return useCallback((template?: AddonTemplate): string => {
    const hasDocuments = useLibraryState((state) => state.entries.length > 0);
    const isAircraftAddon = !!template && isAircraftAddonTemplate(template);
    const isSoftwareAddon = !!template && isSoftwareAddonTemplate(template);

    if (!hasDocuments) {
      return "Get started";
    }

    if (isAircraftAddon) {
      return "Customize";
    }
    if (isSoftwareAddon) {
      return "Import";
    }

    return "Get started";
  }, []);
};
